import React from "react";
import * as styles from "./portfolio.module.css";

interface PortfolioFiltersProps {
  filters: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  className?: string;
}

export const PortfolioFilters: React.FC<PortfolioFiltersProps> = ({
  filters,
  activeFilter,
  onFilterChange,
  className = "",
}) => {
  return (
    <div className={`d-flex flex-wrap justify-content-center mb-4 ${className}`}>
      {filters.map((filter) => {
        const isActive = filter === activeFilter;
        return (
          <button
            key={filter}
            type="button"
            className={`${styles.filterPill} ${
              isActive ? styles.filterPillActive : styles.filterPillInactive
            }`}
            onClick={() => onFilterChange(filter)}
          >
            {filter}
          </button>
        );
      })}
    </div>
  );
};
